import React from "react";
import FitnessGoal from "../components/FitnessGoal";
import { IMAGES } from "../constants/theme";
import FitnessTraining from "../elements/FitnessTraining";
import LatestSlider from "../elements/LatestSlider";
import NewsLetter from "../elements/NewsLetter";
import PageTitle from "../elements/PageTitle";
import WorkoutSlider from "../elements/WorkoutSlider";

const AboutUs = () => {
  return (
    <>
      <div className="page-content bg-white">
        <PageTitle activePage="Libraries" parentTitle="Home" />
        <section
          className="content-inner"
          style={{ backgroundImage: "url(" + IMAGES.BgImage1 + ")" }}
        >
          <div className="container">
            <div className="row about-bx2 align-items-center">
              <FitnessGoal />
            </div>
          </div>
        </section>
        <section className="clearfix">
          <div className="fitness-classes">
            <FitnessTraining />
          </div>
        </section>
      </div>
    </>
  );
};

export default AboutUs;
